var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"buttons-do"},[_c('li',{on:{"click":function($event){return _vm.changeMode(true)}}},[_c('i',{staticClass:"fa fa-th-large",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('li',{staticClass:"border-del",on:{"click":function($event){return _vm.changeMode(false)}}},[_c('i',{staticClass:"fa fa-list-ul",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ffd3f88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/mode.vue
// module id = 153
// module chunks = 0